// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"104":"17b3fea5","419":"17b3fea5","565":"b464622f","601":"fd3a6a3e","839":"cbee792d","952":"cbee792d"}[chunkId] + ".chunk.css";
};